<style lang="scss" scoped>
    .species {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        align-items: center;

        &__image {
            &,
            &--hover {
                display: block;
                width: 100%;
                height: auto;
            }
            &s {
                position: relative;
                &:hover {
                    .species__image--hover {
                        opacity: 1;
                        visibility: visible;
                    }
                }
            }

            &--hover {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
                visibility: hidden;
                transition: opacity $transition-short, visibility $transition-short;
            }
        }
        &__name {
            flex: 0 0 auto;
            display: block;
            width: 100%;
            text-align: center;
            font-size: toRem(20px);
            line-height: lh(31px, 20px);
            letter-spacing: 20px;
            text-indent: 20px;
            text-transform: uppercase;

            @include above(md) {
                font-size: toRem(60px);
                line-height: lh(82px, 60px);
                letter-spacing: 41.6px;
                text-indent: 41.6px;
            }
            &.attract-attention {
                animation-duration: 1s;
                animation-name: drawAttention;
                animation-iteration-count: infinite;
            }
        }
    }
    @keyframes drawAttention {
        0% {
            text-shadow: 0 0 50px rgba(255,255,255,.2);
        }

        50% {
            text-shadow: 0 0 100px rgba(255,255,255,1);
        }

        100% {
            text-shadow: 0 0 50px rgba(255,255,255,.2);
        }
    }
</style>
<template>
    <a href="#!" @click.prevent="handleClick" class="species">
        <div class="species__images">
            <img class="species__image" :src="image">
            <img class="species__image--hover" :src="hoverImage">
        </div>
        <span class="species__name" :class="{'attract-attention': attractAttention}" :style="{color}" v-if="showName">{{ name }}</span>
    </a>
</template>
<script>
export default {
    name: 'Species',
    computed: {
        key() {
            return this.species.key
        },
        name() {
            return this.species.name
        },
        image() {
            return this.forceHover ? this.species.images.poly : this.species.images.wire
        },
        hoverImage() {
            return this.species.images.poly
        },
        color() {
            return this.species.color
        },
    },
    methods: {
        handleClick() {
            if (this.species.tissues) {
                this.$router.push({ name: 'TissueView', params: {species: this.key} })
            } else {
                this.$emit('show-crowdsource')
            }
        },
    },
    props: {
        species: {
            type: Object,
            required: true,
        },
        showName: {
            type: Boolean,
            default: false,
        },
        forceHover: {
            type: Boolean,
            default: false,
        },
        attractAttention: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
